import {
	Component,
	ElementRef,
	OnInit
} from '@angular/core';


import styles from './VbGridList.module.less';

@Component({
	selector: 'vb-grid-list-column',
	template: '<ng-content></ng-content>'
})
export class VbGridListColumnComponent implements OnInit {
	constructor(private el: ElementRef<HTMLElement>) {
	}

	public ngOnInit(): void {
		this.el.nativeElement.classList.add(styles.gridColumn);
	}

}
